import * as constant from "../constants/PlanConstants"

const initialState = {
  plans: [],
  kidsPlan: [],
  IELTSPlan: [],
  planHistory: null,
  currentplan: null,
  transactions: []
};

export const PlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.FETCH_ALL_PLANS:
      return {
        ...state,
        plans: [...action.payload.plansData]
      };
    case constant.FETCH_ALL_PLANS_IELTS:
      return {
        ...state,
        IELTSPlan: [...action.payload.plansData]
      };
    case constant.FETCH_ALL_PLANS_KIDS:
      return {
        ...state,
        kidsPlan: [...action.payload.plansData]
      }
    case constant.CURRENT_PLAN:
      console.log(action.payload)
      return {
        ...state,
        currentplan: action.payload.currentsubscriptions[0],
        planHistory: action.payload.subscriptions
      };
    case constant.FETCH_TRANSACTION:
      console.log(action.payload)
      return {
        ...state,
        transactions: [...action.payload.transaction]
      };
    case constant.UPDATE_STATUS:
      //Filter subscription & update subscription status to paused
      state.planHistory.map(subscription => subscription._id === action.payload.subscriptionId ? subscription["status"] = action.payload.status : "")
      //change current plan status
      if (action.payload.subscriptionId === state.currentplan._id) {
        state.currentplan["status"] = action.payload.status
      }
      return state;
    default:
      return state;
  }
}